import EventViewTabs from './EventViewTabs';

export default EventViewTabs;
